import { isFunction } from 'lodash';
/**
   * @ngdoc directive
   * @name adjust.directive:scrollBar
   * @scope
   * @restrict A
   *
   * @description
   * Scroll bar which is child of the {@link adjust.directive:scroll scroll} container directive
   * Responsible for placing fake scroll bar at the visible area so the horizontal scrolling is possible with
   * mouse dragging instead of just with wheel when native scrollbar is out of the focus
   *
   */
function scrollBar(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: ['scrollBar', '^scroll'],
    template: '<div scroll-thumb="vm.instance"></div>',
    controller: 'ScrollBarController',
    controllerAs: 'vm',
    bindToController: {},
    link: Helper.linkFunction
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:ScrollBarController
   *
   * @description
   * All the functionality of the {@link adjust.directive:scrollBar scrollBar} directive
   *
   */
function ScrollBarController($element) {
  'ngInject';
  var vm = this;

  var _callbacks = {};

  $element.addClass('scroll-bar');

  vm.init = init;
  vm.on = on;
  vm.getElement = getElement;
  vm.getScrollTable = getScrollTable;
  vm.getSide = getSide;
  vm.setNoSelect = setNoSelect;

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Register parent controller and cache the instance
   *
   * @param {Object} parentController parent controller
   *
   */
  function init(parentController) {

    vm.instance = parentController.getInstance();

    vm.parentController = parentController;

    vm.parentController.on('loading:' + vm.instance, _handleChange);
    vm.parentController.on('scroll:left:' + vm.instance, _handleScrollLeft);

  }

  /**
   * @ngdoc method
   * @name _handleChange
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Handle loading change
   *
   * @param {boolean} loading loading state
   * @private
   */
  function _handleChange(loading) {

    _trigger('loading:' + vm.instance, [loading]);

  }

  /**
   * @ngdoc method
   * @name _handleScrollLeft
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Handle scroll left action
   *
   * @param {number} left left position
   * @private
   */
  function _handleScrollLeft(left) {

    _trigger('scroll:left:' + vm.instance, [left]);

  }

  /**
   * @ngdoc method
   * @name on
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Register callback for particular action
   * Exposed for children
   *
   * @param {string} action action to fire
   * @param {Function} callback callback for the action
   */
  function on(action, callback) {

    _callbacks[action] = callback;

  }

  /**
   * @ngdoc method
   * @name _trigger
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Trigger callback for particular action
   *
   * @param {string} action action to fire
   * @param {Array} params params to pass
   * @private
   */
  function _trigger(action, params) {

    if (isFunction(_callbacks[action])) {
      _callbacks[action].apply(null, params);
    }

  }

  /**
   * @ngdoc method
   * @name getElement
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Get scroll bar DOM element
   *
   * @returns {Element} scroll bar DOM element
   */
  function getElement() {

    return $element[0];

  }

  /**
   * @ngdoc method
   * @name getScrollTable
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Get scroll table DOM element
   *
   * @returns {Element} scroll table DOM element
   */
  function getScrollTable() {

    return vm.parentController.getScrollTable();

  }

  /**
   * @ngdoc method
   * @name getSide
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Get side list DOM element
   *
   * @returns {Element} side list DOM element
   */
  function getSide() {

    return vm.parentController.getSide();

  }

  /**
   * @ngdoc method
   * @name setNoSelect
   * @methodOf adjust.controller:ScrollBarController
   *
   * @description
   * Toggle no-select class of the parent element
   *
   * @param {boolean} value set or not
   */
  function setNoSelect(value) {

    vm.parentController.setNoSelect(value);

  }
}

export { ScrollBarController, scrollBar };
